import { ReactComponent as ViaCentralIcon } from '@assets/images/Via/ViaCentralLight.svg';
import LoginImage from '@assets/images/login.jpg';
import { Container, Link as MuiLink, Paper, Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { useIntl } from 'react-intl';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { LocaleToggle } from '../components/LocaleToggle';

export const LoginLayout: React.FC = () => {
  const { formatMessage } = useIntl();

  const location = useLocation();

  const isTrialPage = location.pathname.includes('trial');

  return (
    <Stack
      direction='row'
      flex={1}
      justifyContent='center'
      alignItems='center'
      sx={{
        minHeight: { xs: '100vh', sm: 0 },
        backgroundImage: { xs: 'none', sm: `url(${LoginImage})` },
        backgroundPosition: { sm: 'center center' },
        backgroundRepeat: { sm: 'no-repeat' },
        backgroundSize: { sm: 'cover' }
      }}
    >
     <Container maxWidth="sm" disableGutters sx={{ height: { xs: '100%', sm: 'auto' } }}>
    <Paper
      elevation={0}
      sx={{
        boxShadow: (theme) => ({ xs: 0, sm: theme.shadows[4] }),
        height: { xs: '100%', sm: 'auto' },
        width: { xs: '100%', sm: 'auto' },
        display: { xs: 'flex', sm: 'block' },
        flexDirection: { xs: 'column', sm: 'unset' },
        minHeight: { xs: 0, sm: 'unset' }
      }}
    >
        <Stack flex={1} sx={{ backgroundColor: 'background.paper', minHeight: 0 }}>
          <Stack
            sx={{
              flexShrink: isTrialPage ? 1 : 0,
              transition: 'flex-shrink 0.3s',
              '@media (max-height: 750px)': { flexBasis: 0 }
            }}
            p={2}
            spacing={2}
            bgcolor='primary.main'
            color='primary.contrastText'
            justifyContent='center'
            alignItems='center'
          >
            <Stack direction='row' spacing={2} alignSelf='stretch' justifyContent='flex-end'>
              <LocaleToggle />
            </Stack>
            <ViaCentralIcon style={{ height: 'auto', width: '100%', maxWidth: 180 }} />
            <Typography variant='subtitle1' fontStyle='italic'>
              {formatMessage({ id: 'More than just a customer portal' })}
            </Typography>
          
          </Stack>
          <Outlet />

        </Stack>

        <Paper elevation={4} sx={{ width: '100%' }}>
          <Stack
            alignItems='center'
            justifyContent='center'
            direction='row'
            fontSize={{ xs: '0.7rem', md: '1rem' }}
            py={{ xs: 0.5, md: 2 }}
            gap={0.5}
          >
            <Typography variant='subtitle2' color='text.secondary' fontSize='inherit'>
              {`© ${dayjs().year()}`}
            </Typography>

            {' | '}

            <Typography variant='subtitle2' color='text.secondary' fontSize='inherit'>
              {'ARIV Inc.'}
            </Typography>

            {' | '}

            <Typography variant='subtitle2' color='text.secondary' fontSize='inherit'>
              {formatMessage({ id: 'All rights reserved' })}
            </Typography>

            {' | '}

            <MuiLink component={Link} to='https://ariv.ca/contact' target="_blank">
              {formatMessage({ id: 'Contact us' })}
            </MuiLink>
          </Stack>
        </Paper>
      </Paper>
    </Container>
    </Stack>
  );
};